// Last item at/above the reading line. Items must be in vertical document order.
export default function findReadingIndex(items, top = 160) {
  let low = 0;
  let high = items.length;
  while (low < high) {
    const middle = low + Math.floor((high - low) / 2);
    if (items[middle].element.getBoundingClientRect().top <= top) low = middle + 1;
    else high = middle;
  }
  return low - 1;
}
